import React from 'react';
import { Modal, Row, Col, Progress } from 'antd';
import PlayerTimeline from '../player/PlayerTimeline';
import PlaylistRenderer from '../player/renderers/PlaylistRenderer';
import CodexPlayerHelper from '../player/CodexPlayerHelper';
import SignageScreenLayout from '../player/SignageScreenLayout';
import moment from 'moment';
import { Play, Monitor, X } from 'lucide-react';

class ScreenPreviewPopup extends React.Component {
    state = {
        previewScreenVisible: false,
        contentjson: null,
        currentTimelineElement: null,
        previewAspect: 16 / 9,
        previewLabel: null
    };

    constructor(props) {
        super(props);

        this.previewTimelineRef = React.createRef();
        this.layoutRef = React.createRef();
    }

    getCurrentTimeline = () => {
        var d = new moment();

        // console.log("current time " + new Date())

        // if(this.state.contentjson.timeline.length>0 && ("duration" in this.state.contentjson.timeline[0]))
        // {
        //     for(var i=0; i<this.state.contentjson.timeline.length; i++)
        //     {
        //         totalDuration += this.state.contentjson.timeline[i];
        //     }
        // }

        if (!this.state.contentjson)
            return null;
        for (var i = 0; i < this.state.contentjson.campaign.length; i++) {
            const timeline = this.state.contentjson.campaign[i];

            if (true) {//(Settings.MODE === Settings.MODE_PREVIEW && Settings.IGNORETIME) {
                return timeline;
            }
            else
                if ("startdate" in timeline && "enddate" in timeline) {
                    // console.log("has start end time");
                    // var startDateArr = timeline.startdate.split("-");
                    // var endDateArr = timeline.enddate.split("-");

                    var startDate = (timeline.startdate === "") ? moment().add(-1, 'days') : moment(
                        timeline.startdate + "T00:00",
                        "YYYY-MM-DDTHH:mm"
                    );
                    var endDate = (timeline.startdate === "") ? moment().add(1, 'days') : moment(
                        timeline.startdate + "T00:00",
                        "YYYY-MM-DDTHH:mm"
                    );


                    // var endDate = moment("2020-05-31" + "T23:59", 'YYYY-MM-DDTHH:mm');

                    var timelineStartTime = "00:00";
                    var timelineEndTime = "00:00";

                    if (timeline.starttime !== null && timeline.starttime !== "") {
                        timelineStartTime = timeline.starttime;
                    }
                    if (timeline.endtime !== null && timeline.endtime !== "") {
                        timelineEndTime = timeline.endtime;
                    }

                    //override with weekday starttime endtime if exist
                    if ("weekday_schedule" in timeline) {
                        // console.log("weekday " + d.day());
                        const scheduleObjs = timeline.weekday_schedule.filter((weekdayObj) => {
                            // console.log("weekdayObj.day " + weekdayObj.day)
                            return weekdayObj.day.split(",").indexOf(`${d.day()}`) != -1;
                        });

                        const matchedSchedule = scheduleObjs.find((scheduleObj) => {
                            // console.log(" week day " + d.day() + scheduleObj)

                            var sceduleStartTime = timelineStartTime
                            var sceduleEndTime = timelineEndTime
                            var sceduleStartDate = startDate
                            var sceduleEndDate = endDate

                            if (scheduleObj !== null && scheduleObj !== undefined) {
                                if (scheduleObj.starttime !== null && scheduleObj.starttime !== "") {
                                    sceduleStartTime = scheduleObj.starttime;
                                }
                                if (scheduleObj.endtime !== null && scheduleObj.endtime !== "") {
                                    sceduleEndTime = scheduleObj.endtime;
                                }
                                else {
                                    sceduleEndTime = "23:59";
                                }

                                // add schedule start date end date
                                if (scheduleObj.startdate !== null && scheduleObj.startdate !== "") {
                                    sceduleStartDate = moment(
                                        scheduleObj.startdate + "T00:00",
                                        "YYYY-MM-DDTHH:mm")
                                }
                                if (scheduleObj.enddate !== null && scheduleObj.enddate !== "") {
                                    sceduleEndDate = moment(
                                        scheduleObj.enddate + "T23:59",
                                        "YYYY-MM-DDTHH:mm")
                                }
                                else {
                                    sceduleEndDate = (scheduleObj.enddate === "") ? moment().add(1, 'days') : moment(scheduleObj.enddate + "T23:59", "YYYY-MM-DDTHH:mm");
                                }

                            }

                            const startTimeString =
                                moment(d).format("YYYY-MM-DD") + "T" + sceduleStartTime;
                            const endTimeString =
                                moment(d).format("YYYY-MM-DD") + "T" + sceduleEndTime;
                            var startTime = moment(startTimeString, "YYYY-MM-DDTHH:mm");
                            var endTime = moment(endTimeString, "YYYY-MM-DDTHH:mm");

                            // console.log("sceduleStartTime " + startTime.format('MMMM Do YYYY, h:mm:ss a'))
                            // console.log("sceduleEndTime " + endTime.format('MMMM Do YYYY, h:mm:ss a'))
                            // console.log("sceduleStartDate " + sceduleStartDate.format('MMMM Do YYYY, h:mm:ss a'))
                            // console.log("sceduleEndDate " + sceduleEndDate.format('MMMM Do YYYY, h:mm:ss a'))
                            // console.log("d.isBetween(sceduleStartDate, sceduleEndDate) " + d.isBetween(sceduleStartDate, sceduleEndDate))
                            // console.log("d.isBetween(startTime, endTime) " + d.isBetween(startTime, endTime))
                            if (
                                d.isBetween(sceduleStartDate, sceduleEndDate) &&
                                d.isBetween(startTime, endTime)
                            ) {
                                return true;
                            }

                            return false;
                        })

                        if (matchedSchedule)
                            return timeline;
                    }

                    const startTimeString =
                        moment(d).format("YYYY-MM-DD") + "T" + timelineStartTime;
                    const endTimeString =
                        moment(d).format("YYYY-MM-DD") + "T" + timelineEndTime;
                    var startTime = moment(startTimeString, "YYYY-MM-DDTHH:mm");
                    var endTime = moment(endTimeString, "YYYY-MM-DDTHH:mm");

                    if (
                        d.isBetween(startDate, endDate) &&
                        d.isBetween(startTime, endTime)
                    ) {
                        return timeline;
                    }
                }
        }

        return null;
    };

    getCurrentTimelineElement = (currentTimeLine) => {
        if (currentTimeLine === null) {
            // console.log("no timeline");
            return null;
        }


        if (currentTimeLine.timeline_element.length) {
            return currentTimeLine.timeline_element[0];
        }

        var d = new Date();
        // if(this.state.contentjson.timeline.length>0 && ("duration" in this.state.contentjson.timeline[0]))
        // {
        //     for(var i=0; i<this.state.contentjson.timeline.length; i++)
        //     {
        //         totalDuration += this.state.contentjson.timeline[i];
        //     }
        // }

        for (var i = currentTimeLine.timeline_element.length - 1; i >= 0; i--) {
            // for (var i = 0; i < currentTimeLine.timeline_element.length; i++) {
            const timelineElement = currentTimeLine.timeline_element[i];

            //console.log("yo " + (("start_time" in timelineElement) && ("end_time" in timelineElement)));

            if (
                "startplaytime" in timelineElement &&
                "endplaytime" in timelineElement
            ) {
                // console.log("has start end time");
                var startTimeArr = timelineElement.startplaytime.split(":");
                var endTimeArr = timelineElement.endplaytime.split(":");

                var startTimeD = new Date();
                startTimeD.setHours(startTimeArr[0], startTimeArr[1], 0, 0);

                var endTimeD = new Date();
                endTimeD.setHours(endTimeArr[0], endTimeArr[1], 0, 0);

                if (d >= startTimeD && d <= endTimeD) {
                    return timelineElement;
                }
            } else if (
                "startplaytime" in timelineElement &&
                "duration" in timelineElement
            ) {
                // console.log("has start end time");
                var startTimeArr = timelineElement.startplaytime.split(":");

                var startTimeD = new Date();
                startTimeD.setHours(startTimeArr[0], startTimeArr[1], 0, 0);

                var endTimeD = new Date(startTimeD.getTime());
                endTimeD.setSeconds(
                    endTimeD.getSeconds() + timelineElement.duration,
                    0
                );

                if (d >= startTimeD && d <= endTimeD) {
                    return timelineElement;
                }
            } else if ("duration" in timelineElement) {
                // console.log("has duration");
                const lastElement =
                    currentTimeLine.timeline_element[
                    currentTimeLine.timeline_element.length - 1
                    ];
                const totalTimelineDuration =
                    lastElement.duration + lastElement.stackedDuration;

                const runningDuration = this.state.time % totalTimelineDuration;

                // const endTime = timelineElement.stackedDuration + timelineElement.duration;
                // console.log("Stacked TIME : " + timelineElement.stackedDuration);
                // console.log("END TIME : " + timelineElement.stackedDuration);

                if (
                    timelineElement.stackedDuration <= runningDuration &&
                    runningDuration <
                    timelineElement.stackedDuration + timelineElement.duration
                ) {
                    if (this.state.currentTimelineElement != timelineElement) {
                        if (this.layoutRef.current) {
                            this.layoutRef.current.reset();
                        }
                    }

                    // console.log(timelineElement);
                    return timelineElement;
                }
            } else if (
                "start_time" in timelineElement &&
                "end_time" in timelineElement
            ) {
                // console.log("has start end time");
                var startTimeArr = timelineElement.start_time.split(":");
                var endTimeArr = timelineElement.end_time.split(":");

                var startTimeD = new Date();
                startTimeD.setHours(startTimeArr[0], startTimeArr[1], 0, 0);
                var endTimeD = new Date();
                endTimeD.setHours(endTimeArr[0], endTimeArr[1], 0, 0);

                if (d >= startTimeD && d <= endTimeD) {
                    return timelineElement;
                }
            }
        }

        return null;
    };

    showPreviewPlaylist = (data = null, doShow = true) => {
        // console.log("data " + JSON.stringify(data))
        return new Promise((resolve, reject) => {

            this.setState({ contentjson: data, previewScreenVisible: doShow }, () => {

                const currentTimeline = this.getCurrentTimeline();

                const currentTimelineElement = this.getCurrentTimelineElement(
                    currentTimeline
                );

                this.setState({ currentTimelineElement: currentTimelineElement });

                resolve();
            });
        })
    }

    stopPreviewPlaylist = () => {
        if (this.previewTimelineRef.current)
            this.previewTimelineRef.current.stopTimer();
        this.showPreviewPlaylist(null, false);
    }

    //callthis function to preview playlist
    previewContent = (contentjsondata, previewDims) => {

        if (previewDims && (previewDims.aspect || (previewDims.width && previewDims.height))) {
            const aspect = previewDims.aspect
                ? previewDims.aspect
                : previewDims.width / previewDims.height;
            this.setState({
                previewAspect: aspect > 0 ? aspect : 16 / 9,
                previewLabel: previewDims.label || null
            });
        } else {
            this.setState({ previewAspect: 16 / 9, previewLabel: null });
        }

        this.showPreviewPlaylist(contentjsondata, true).then(() => {
            if (this.previewTimelineRef.current) {
                this.previewTimelineRef.current.resetTimer();
                this.previewTimelineRef.current.startTimer(contentjsondata);
            }
        })
    }

    render() {
        const campaignName = this.state.contentjson && this.state.contentjson.campaign_name
            ? this.state.contentjson.campaign_name
            : 'Screen preview';

        // Fit the player box to the requested aspect ratio within a max area
        const aspect = this.state.previewAspect || (16 / 9);
        const MAX_W = 720;
        const MAX_H = 500;
        let boxW = MAX_W;
        let boxH = MAX_W / aspect;
        if (boxH > MAX_H) {
            boxH = MAX_H;
            boxW = MAX_H * aspect;
        }
        boxW = Math.round(boxW);
        boxH = Math.round(boxH);

        return (
            <Modal
                title={null}
                centered
                open={this.state.previewScreenVisible}
                footer={null}
                onOk={() => this.stopPreviewPlaylist()}
                onCancel={() => this.stopPreviewPlaylist()}
                wrapClassName="modal-window"
                width={Math.max(380, boxW + 72)}
                closeIcon={<span style={{ display:'inline-flex', width:32, height:32, borderRadius:8, background:'rgba(255,255,255,0.12)', alignItems:'center', justifyContent:'center' }}><X size={16} color="#fff" /></span>}
                bodyStyle={{ padding: 0, background: '#0f172a', borderRadius: 12, overflow: 'hidden' }}
            >
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '18px 24px 16px', background: 'linear-gradient(135deg, #1e293b, #0f172a)', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                    <div style={{ width: 40, height: 40, borderRadius: 10, background: 'linear-gradient(135deg, #6366f1, #4f46e5)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <Play size={18} color="#fff" fill="#fff" />
                    </div>
                    <div>
                        <div style={{ fontSize: 16, fontWeight: 700, color: '#f8fafc' }}>{campaignName}</div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 3 }}>
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: 'rgba(99,102,241,0.2)', color: '#a5b4fc', borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 600 }}>
                                <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#6366f1', display: 'inline-block', animation: 'pulse 2s infinite' }} />
                                LIVE PREVIEW
                            </span>
                            <span style={{ fontSize: 11, color: '#475569' }}>· Real-time playback</span>
                        </div>
                    </div>
                </div>

                {/* Player area */}
                <div style={{ background: '#0f172a', padding: '28px 24px 24px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    {/* Monitor frame */}
                    <div style={{ background: '#1e293b', borderRadius: 16, padding: 12, boxShadow: '0 0 0 1px rgba(255,255,255,0.06), 0 24px 48px rgba(0,0,0,0.5)', width: boxW + 24 }}>
                        {/* Screen bezel top */}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, paddingLeft: 4, paddingRight: 4 }}>
                            <div style={{ display: 'flex', gap: 5 }}>
                                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#ef4444', display: 'inline-block' }} />
                                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#f59e0b', display: 'inline-block' }} />
                                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#10b981', display: 'inline-block' }} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 5, color: '#475569', fontSize: 11 }}>
                                <Monitor size={11} color="#475569" /> {this.state.previewLabel || 'Screen Preview'}
                            </div>
                            <div style={{ width: 44 }} />
                        </div>
                        {/* Actual player */}
                        <div style={{ borderRadius: 8, overflow: 'hidden', background: '#000', width: boxW, height: boxH, margin: '0 auto' }}>
                            <PlayerTimeline ref={this.previewTimelineRef} backgroundColor="transparent" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                                {(time) => {
                                    if (this.layoutRef.current) {
                                        this.layoutRef.current.onTick();
                                    }
                                    const currentTimeline = this.getCurrentTimeline();

                                    if (!currentTimeline) {
                                        return <div style={{ backgroundColor: 'black', width: '100%', height: '100%' }} />;
                                    }
                                    const currentTimelineElement = this.getCurrentTimelineElement(currentTimeline);

                                    if (!currentTimelineElement) {
                                        return <div style={{ backgroundColor: 'black', width: '100%', height: '100%' }} />;
                                    }

                                    if (currentTimelineElement !== this.state.currentTimelineElement)
                                        this.setState({ currentTimelineElement: currentTimelineElement });

                                    const layoutdata = this.state.currentTimelineElement.layout;
                                    return <SignageScreenLayout
                                        screenwidth={boxW}
                                        screenheight={boxH}
                                        debug={false}
                                        brand={""}
                                        mall={""}
                                        unit={""}
                                        controls={false}
                                        ref={this.layoutRef}
                                        contentjson={this.state.contentjson}
                                        timelinedata={this.state.currentTimelineElement}
                                        layoutdata={layoutdata}
                                    />;
                                }}
                            </PlayerTimeline>
                        </div>
                    </div>
                    {/* Footer label */}
                    <div style={{ marginTop: 14, fontSize: 11, color: '#334155', textAlign: 'center' }}>
                        Previewing as it would appear on a signage screen
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ScreenPreviewPopup